import type { FC } from 'react';
import React from 'react';
import classNames from 'classnames';

import type { TIconButton } from './models';

export const IconButton: FC<React.PropsWithChildren<TIconButton>> = ({
    alt = 'иконка',
    children,
    className,
    height = 18,
    src,
    styles,
    width = 18,
    ...rest
}) => (
    <button className={classNames(styles.iconButton, className)} {...rest}>
        {children || <img alt={alt} height={height} src={src} width={width} />}
    </button>
);
